import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DataService } from "../base-data-services/data.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { MentorMappingListModel } from "common/models/page-models/mentor-mapping/mentor-mapping-model";
 
@Injectable()
export class MentorMappingListDataService extends DataService<MentorMappingListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getMentorMasterData,http);
    }
 
 
//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
   
    createInstance(): MentorMappingListModel {
        return new MentorMappingListModel();
    }

    
 
}